export const BLUECONIC_LOWA_SEGMENTS = [
  "MICH LOWA", "OHIO LOWA", "PENN LOWA", "NY LOWA", "BOSTON LOWA", "NORCAL LOWA",
  "TWIN CITIES LOWA", "DENV/PMP LOWA", "SCNG LOWA", "BANG LOWA", "AMC LOWA", "HC LOWA", "GS LOWA",
  "ORL LOWA", "SS LOWA", "NNDP LOWA", "VP LOWA", "NYDN LOWA", "BAL LOWA", "CG LOWA", "CHI LOWA",
] as const;

export const BLUECONIC_LOWA_COOKIE_NAME = "bc_lowa_status";

export const BLUECONIC_DEFAULT_TIMEOUT_MS = 3000;

export const BLUECONIC_PROFILE_READY_TIMEOUT_MS = 3000;

export const BLUECONIC_LOAD_VALUES_TIMEOUT_MS = 3000;

export const BLUECONIC_LOWA_COOKIE_EXPIRES_SECONDS = 7 * 24 * 60 * 60;
